import { TextFieldProps } from '@mui/material/TextField/TextField';

import { theme } from '~/theme';

export const useSxStyles = (props: { margin: TextFieldProps['margin'] }) => {
  const { margin } = props;

  const getFieldMargin = () => {
    switch (margin) {
      case 'normal':
        return theme.spacing(2, 0, 1, 0);
      case 'dense':
        return theme.spacing(1, 0, 0.5, 0);
      default: {
        return theme.spacing(0);
      }
    }
  };

  return {
    root: {
      display: 'flex',
      gap: theme.spacing(0.25),
      alignItems: 'center',
      margin: getFieldMargin(),
      '&.fullWidth': {
        width: '100%',
      },
    },
    fileInput: {
      display: 'none',
    },
    selectedFile: {
      display: 'flex',
      alignItems: 'stretch',
      '&.hasAttachmentUrl .MuiInputBase-root': {
        borderRadius: theme.spacing(0.5, 0, 0, 0.5),
      },
      '&.fullWidth': {
        width: '100%',
      },
    },
    downloadDivider: {
      padding: theme.spacing(0, 0.25),
      border: `solid 1px ${theme.palette.action.disabled}`,
      borderLeftWidth: 0,
      borderRadius: theme.spacing(0, 0.5, 0.5, 0),
      display: 'flex',
      alignItems: 'center',
    },
  };
};
